import React from 'react';
import MainCalculatorsList from '../MainCalculators';
import SharedHelmet from '../Helmet';
import SharedGPAPlanner from './SharedGPAPlanner';
import RelatedLinks from '../RelatedLinks';
import { CalculatorsType } from '../ConstantsEN';
import { FirstAds, SecondAds, MobileUnderCalAds } from '../../Ads';
import StudyCalculatorImg from '../../../images/StudyCalculatorImg.webp';

const TITLE = 'Effective Cumulative GPA Planning';
const DESCRIPTION =
  'Learn how to plan your cumulative GPA effectively for your college courses. Discover the best strategies to improve and plan your cumulative GPA for academic success.';
const KEYWORDS = 'Cumulative GPA Planning, GPA Planning Strategies, Improve Cumulative GPA, Academic Success';
const OG_URL = 'https://do-calculate.com/calculator/en/gpaplanner/';

function GPAPlanner() {
  return (
    <div className="ltr">
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
        IMAGE={StudyCalculatorImg}
      />

      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
      </div>

      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div className="bg-success text-white text-center" style={{ height: '40px' }}>
            <h1 style={{ fontSize: '17px' }}>{TITLE}</h1>
          </div>

          <div className="border border-light">
            <div className="row">
              <div>
                <p>{DESCRIPTION}</p>
                <hr />
              </div>
            </div>

            <MobileUnderCalAds />

            <div className="row">
              <SharedGPAPlanner />
            </div>

            <br />
            <hr />
            <hr />

            <div className="row">
              <RelatedLinks />
              <hr />
            </div>
          </div>
        </div>

        <div className="col">
          <SecondAds />
          <br />
          <MainCalculatorsList CalculatorsTypeId={CalculatorsType.studyCalculators} />
          <br />
        </div>
      </div>

      <div className="row" style={{ height: 'auto' }}>
        <div className="col-12 col-md-8">
          <div className="info-sections-container">
            <div className="info-section">
              <div className="info-section-header">{TITLE}</div>
              <div className="info-section-body">
                <u>
                  <h2 style={{ fontSize: '16px' }}>{TITLE}</h2>
                </u>

                <p>
                  Every student has their own learning style. Some people prefer to work for long continuous hours to
                  complete a specific task, while others may take several breaks. There is no one-size-fits-all strategy,
                  and how a person approaches learning largely depends on their learning style, as well as their
                  commitment to a study strategy that fits their schedule and preferences. The method that maximizes the
                  use of time is likely to be the most effective in improving the learning process and, consequently,
                  improving the cumulative GPA.
                </p>

                <p>
                  Organizing tasks and notes are equally important. It's not enough to take notes in class — you must be
                  able to find information when you need it. Notes become significantly valuable when they support the
                  learning process. Professors provide large amounts of information during lectures, and it's not
                  necessary to process all of it at once. Practicing a note-taking style that allows you to refer back
                  and search for information later is key.
                </p>

                <p>
                  Time management is a critical part of GPA planning. There are only 24 hours in a day, and taking on
                  more courses or activities than you can handle can be detrimental to both learning and your cumulative
                  GPA. Once all courses are identified, allocating dedicated time for each helps put the workload in
                  perspective — reducing stress and increasing efficiency.
                </p>

                <p>
                  Regularly reviewing course material is another cornerstone of effective time management. A large
                  amount of information is covered before the final exam, and spacing out review sessions over time is
                  consistently more effective than last-minute cramming. Regular review can save time overall and
                  position you to perform better on exams — directly improving your cumulative GPA.
                </p>

                <hr />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default GPAPlanner;